import { Component, type ErrorInfo, type ReactNode } from "react";

export interface EfFatalErrorBoundaryProps {
	onFatal: (error: Error, errorInfo: ErrorInfo) => void;
	children: ReactNode;
}

interface EfFatalErrorBoundaryState {
	hasCrashed: boolean;
}

export class EfFatalErrorBoundary extends Component<
	EfFatalErrorBoundaryProps,
	EfFatalErrorBoundaryState
> {
	public constructor(props: EfFatalErrorBoundaryProps) {
		super(props);

		this.state = {
			hasCrashed: false,
		};
	}

	public static getDerivedStateFromError(): EfFatalErrorBoundaryState {
		return {
			hasCrashed: true,
		};
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
		this.props.onFatal(error, errorInfo);
	}

	public render(): ReactNode {
		if (this.state.hasCrashed) {
			return null;
		}

		return this.props.children;
	}
}

export default EfFatalErrorBoundary;